import { AcademicCapIcon, ArrowUpIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

/**
 * Empty state inicial da tela **Configuração de Nota e Frequência** — corresponde ao frame
 * "B — Barra de contexto + empty state" do protótipo. Exibido enquanto nenhuma turma está
 * selecionada: ícone em círculo, título, descrição e uma pílula de dica que aponta para o
 * campo de busca de turma acima.
 */
export function GradeConfigEmptyState() {
  const { t } = useTranslation('gradeAttendanceConfig');

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-xxs rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface px-xxs py-xl">
      <div className="flex size-xl items-center justify-center rounded-circular bg-ctx-layout-body">
        <AcademicCapIcon className="size-xs text-ctx-content-placeholder" />
      </div>

      <h2 className="text-ctx-content-title ts-heading-xs">{t('emptyState.title')}</h2>

      <p className="max-w-[26rem] text-center text-ctx-content-base ts-paragraph-xs">
        {t('emptyState.description')}
      </p>

      <div className="flex items-center gap-quark rounded-pill bg-ctx-layout-body px-xxs py-quark">
        <ArrowUpIcon className="size-mini text-ctx-content-base" />
        <span className="text-ctx-content-base ts-caption-xxs">{t('emptyState.hint')}</span>
      </div>
    </div>
  );
}
